import React from "react";
import PropTypes from "prop-types";

import ColumnItem from "./ColumnItem";
import ActionButton
    from "lib/common/descriptorcontrols/BaseControls/ActionButton";
import formatId from "lib/formatId";
import { recordIdType } from "data/util/typedefs";
import ErrorBoundary from "lib/common/components/ErrorBoundary";

function NavigatorColumn(props) {
    const {
        items,
        showRemove,
        active,
        label,
        showAdd,
        creatables,
        onSelectItem,
        ITid,
        onExpansionChange,
    } = props;

    const addOnClick = (event, d, v) => {
        const {onAddItem} = props;
        onAddItem && onAddItem(v.value);
    };

    const removeOnClick = (event) => {
        event.preventDefault();
        props.onRemove();
    };

    const selectedRef = React.useRef(null);
    let selectedRecord = null;
    let selectedKey = null;
    const itemElements = items.map(it => {
        if (it.selected) {
            selectedRecord = it;
            selectedKey = `${selectedRecord.entityKey}#${selectedRecord.recordId}`;
        }
        return (
            <ColumnItem
                ref={it.selected ? selectedRef : null}
                key={it.cid}
                ITid={ITid + "-" + it.cid}
                label={it.label}
                datakey={it.implKey}
                nestLevel={it.nestLevel}
                selected={it.selected}
                childCount={it.childCount}
                expanded={it.nestLevel === 0 && it.expanded}
                onSelect={() => onSelectItem(it)}
                changeExpanded={() => onExpansionChange(it.implKey)}
            />);
    });
    const activeClass = active ? "active" : "";

    React.useEffect(
        () => {
            if (!selectedRef.current) return;
            selectedRef.current.scrollIntoView(false);
        },
        [selectedRef, selectedKey]
    );

    const headerStyle = {
        position: "relative",
    };

    return <ErrorBoundary>
            <div className={`column ${activeClass}`} id={formatId(ITid, "nav-col")}>
                <header style={headerStyle}>
                    <span className="column-header">{label}</span>
                    {showAdd && (
                        <ActionButton
                            actionType={"add"}
                            dataAlign={"right"}
                            enabled={true}
                            onClick={addOnClick}
                            options={creatables}
                        />
                    )}
                    {(showRemove && !!selectedRecord) && (
                        <ActionButton
                            actionType={"remove"}
                            dataAlign={"right"}
                            enabled={true}
                            onClick={removeOnClick}
                            entityKey={selectedRecord.entityKey}
                            disableBehaviour={"disable"}
                        />
                    )}
                </header>

                <ul className="list-unstyled items">
                    {itemElements}
                </ul>
            </div>
        </ErrorBoundary>;
}

NavigatorColumn.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            cid: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            key: PropTypes.string, // not present for "all impls"
            implKey: PropTypes.string,
            entityKey: PropTypes.string,
            recordId: recordIdType,
            nestLevel: PropTypes.number, // only for first column
            label: PropTypes.string.isRequired,
            selected: PropTypes.bool.isRequired,
            childCount: PropTypes.number.isRequired,
        })
    ).isRequired,
    implKey: PropTypes.string,
    showRemove: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    showAdd: PropTypes.bool.isRequired,
    creatables: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            implKey: PropTypes.string.isRequired,
        })
    ),
    onAddItem: PropTypes.func,
    onRemove: PropTypes.func,
    onSelectItem: PropTypes.func.isRequired,
    onExpansionChange: PropTypes.func, // only magic root forms column
    ITid: PropTypes.any
};

export default NavigatorColumn;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/NavigatorColumn.js